import React from 'react';
import { ProjectDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import ProjectDrillDownTableRow from '../ProjectDrillDownTableRow/ProjectDrillDownTableRow';

type ProjectDrillDownTableBodyProps = {
  items: Array<ProjectDrillDownItem>;
  readOnly?: boolean;
};

const ProjectDrillDownTableBody: React.FC<ProjectDrillDownTableBodyProps> = ({
  items,
  readOnly = false,
}) => {
  return (
    <tbody>
      {items.map((item) => (
        <ProjectDrillDownTableRow
          key={item.id}
          item={item}
          readOnly={readOnly}
        />
      ))}
    </tbody>
  );
};

export default ProjectDrillDownTableBody;
